// As APIs por escola (comunicados, galerias, atividades) trabalham só com uuids
// de aluno, mas o resto do app (StudentSelector, ClassroomsWithStudents) trabalha
// com ids numéricos. ClassroomsWithStudents é a única tabela de tradução entre os
// dois espaços.

const findStudentByUuid = (
  classroomList: ClassroomStudents[],
  studentUuid: string
): { student: Student; classroom: ClassroomStudents } | null => {
  for (const classroom of classroomList) {
    const student = classroom.students.find((s) => s.uuid === studentUuid);
    if (student) return { student, classroom };
  }

  return null;
};

const findStudentById = (
  classroomList: ClassroomStudents[],
  studentId: number
): { student: Student; classroom: ClassroomStudents } | null => {
  for (const classroom of classroomList) {
    const student = classroom.students.find((s) => s.id === studentId);
    if (student) return { student, classroom };
  }

  return null;
};

export const toStudentUuids = (
  studentIds: number[],
  unmatchedStudentUuids: string[],
  classroomList: ClassroomStudents[]
): string[] => {
  const selected = studentIds
    .map((studentId) => findStudentById(classroomList, studentId)?.student.uuid)
    .filter((uuid): uuid is string => Boolean(uuid));
  // O PUT substitui a lista inteira de destinatários, então quem não aparece
  // nas turmas que o usuário vê (formou, trocou de escola, está numa turma de
  // outro professor) precisa voltar junto — senão salvar uma edição apagaria
  // esses alunos.
  return Array.from(new Set([...selected, ...unmatchedStudentUuids]));
};

export const recipientsToStudentIds = (
  recipients: { studentUuid: string }[],
  classroomList: ClassroomStudents[]
): { classroomIds: number[]; studentIds: number[]; unmatchedStudentUuids: string[] } => {
  const studentIds: number[] = [];
  const classroomIds: number[] = [];
  const unmatchedStudentUuids: string[] = [];

  recipients.forEach((recipient) => {
    const match = findStudentByUuid(classroomList, recipient.studentUuid);
    if (!match) {
      unmatchedStudentUuids.push(recipient.studentUuid);
      return;
    }

    studentIds.push(match.student.id);
    if (!classroomIds.includes(match.classroom.id)) classroomIds.push(match.classroom.id);
  });

  return { classroomIds, studentIds, unmatchedStudentUuids };
};
